import React from 'react';
import { Modal, Button, Input, Select } from 'antd';

interface FileSaveModalProps {
  visible: boolean;
  onCancel: () => void;
  fileDetails: { name: string; type: string | undefined };
  setFileDetails: (val: any) => void;
  onSave: () => void;
  onSaveAndAdd: () => void;
  isLoading: boolean;
}

const FileSaveModal: React.FC<FileSaveModalProps> = ({ visible, onCancel, fileDetails, setFileDetails, onSave, onSaveAndAdd, isLoading }) => {
  return (
    <Modal
      open={visible}
      title="SAVE DATASET TO FILE MANAGER"
      onCancel={onCancel}
      footer={
        <div className="footerContent">
          <Button loading={isLoading} disabled={!fileDetails.name || !fileDetails.type} onClick={onSave}>
            Save
          </Button>
          <Button loading={isLoading} disabled={!fileDetails.name || !fileDetails.type} onClick={onSaveAndAdd}>
            Save and Add to Map
          </Button>
        </div>
      }
      width={500}
      className="fileSaveModal"
    >
      <div className="inputGroup">
        <div className="fieldRow">
          <label className="fieldLabel">DATASET NAME</label>
          <Input placeholder="Enter Layer Name" value={fileDetails.name} onChange={(e) => setFileDetails({ ...fileDetails, name: e.target.value })} />
        </div>
        <div className="fieldRow">
          <label className="fieldLabel">FILE TYPE</label>
          <Select
            placeholder="Select File Type"
            value={fileDetails.type}
            onChange={(val) => setFileDetails({ ...fileDetails, type: val })}
            options={[
              { label: 'ShapeFile', value: 'shapefile' },
              { label: 'Geojson', value: 'geojson' },
              { label: 'KML', value: 'kml' },
            ]}
          />
        </div>
      </div>
    </Modal>
  );
};

export default FileSaveModal;
